import { enterPusherChannelAndBindEvents, leavePusherChannel } from 'utils/realTimeEventHelpers';

const course_events = [
  {
    event_name: 'student_joined_course',
    action_name: 'addStudentToCourse',
  },
  {
    event_name: 'toggle_course_chat',
    action_name: 'socketToggleCourseChat',
  },
  {
    event_name: 'send_chat_message',
    action_name: 'socketSendChatMessage',
  },
  {
    event_name: 'load_new_message',
    action_name: 'socketLoadChatMessage',
  },
  {
    event_name: 'delete_chat_message',
    action_name: 'socketDeleteChatMessage',
  },
  {
    event_name: 'delete_all_chat_messages',
    action_name: 'socketDeleteAllChatMessages',
  },
  {
    event_name: 'delete_course_from_school',
    action_name: 'SOCKET_deleteCourseFromSchool',
  },
  {
    event_name: 'invite_co_teacher',
    action_name: 'inviteCoTeacherNotification',
  },
];

const presence_channel_events = [
  {
    event_name: 'pusher:subscription_succeeded',
    handler: async function () {
      
    }
  },
  {
    event_name: 'pusher:member_added',
    handler: (/* member, context */) => {
    },
  },
  
  {
    event_name: 'pusher:member_removed',
    handler: async (/* member, context */) => {
    },
  },
];
export default {
  data() {
    return {};
  },
  computed: {},
  methods: {
    setupCourseSocket(course_id) {
      enterPusherChannelAndBindEvents.call(this, course_id, course_events);
      enterPusherChannelAndBindEvents.call(this, `presence-course-${course_id}`, presence_channel_events);
    },
    leaveCourseSocket: async function(course_id) {
      leavePusherChannel(course_id);
      leavePusherChannel(`presence-course-${course_id}`);
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/mixins/sockets/courseSocketEvents.js